<form [formGroup]="targetForm" [ngClass]="{'form-previously-submitted' : targetFormSubmitted}">
    
    <section class="sideRight-body ei-add-employee-shelf">

        <div id="container-header">
            <div id="contentD">
                <i class="fas fa-user">
                </i>
            </div>
            
            <div id="contentE">
                <h4><b>Employee Details</b></h4>
            </div>
        </div>

        <div id="container">
            <div id="contentA"  class="ei-employeeNumber mt-2">
                <label for="ei-employeeNumber">
                    <i class="fas fa-asterisk"></i> Employee Number
                    <span *ngIf="f.employeeNumber.errors && (f.employeeNumber.touched || f.employeeNumber.dirty) && !isEmpValueEntered">
                        <span class="required-error" *ngIf="f.employeeNumber.errors.required">(required)</span>
                    </span>
                    <input id="emp-number" class="black-input opposite-colors" [ngClass]="{'ng-invalid': employeeNumberError}"
                        (change)="checkEmployeeNumber()" placeholder="Unique number" type="text" no-special-chars="#!$%^<>+='" maxlength="100"
                        (blur)="trimSpecialChar('employeeNumber');" (input)="inputChanged(); isValueEntered()"  formControlName="employeeNumber" required>
                    </label>
            </div>
            
            <div id="contentB" class="ei-name mt-2">
                <label for="ei-name">
                    <i class="fas fa-asterisk"></i> Employee Name
                    <span *ngIf="f.name.errors && (f.name.touched || f.name.dirty) && !isEmpValueEntered">
                        <span class="required-error" *ngIf="f.name.errors.required">(required)</span>
                    </span>
                    <div class="input-elm">
                    <input id="emp-name" class="black-input opposite-colors" placeholder="Name of employee" type="text" pattern="[^'\x22\x60]+" maxlength="100"
                    (blur)="trimSpecialChar('name')" (input)="inputChanged(); isValueEntered()" (selectItem)="dropdownInputChanged()"
                    formControlName="name" required [kpmgUiTypeahead]="searchSMEStream" [inputFormatter]="isValueEntered()">
                    <span class="search-icon"><i class="fas fa-search"></i></span>
                </div>
                </label>
            </div>
            
        </div>
        <!--
        <div class="ei-name mt-2">
            <label for="ei-name">
                Employee Name*
                <span *ngIf="f.name.errors && (f.name.touched || f.name.dirty) && !isEmpValueEntered">
                    <span class="required-error" *ngIf="f.name.errors.required">(required)</span>
                </span>
                <input id="emp-name" class="black-input opposite-colors" placeholder="Name of Employee" type="text" no-special-chars="#!$%^<>+='" maxlength="100"
                (blur)="trimSpecialChar('name');" (input)="inputChanged(); isValueEntered()"  formControlName="name" required>
            </label>
        </div>
        -->

        <p class="section-info">Employee number needs to be defined.</p>
        
        <div class="form-error-sign section-info" *ngIf="">
            <p>Employee number is not valid.</p>
        </div>

        <div id="container">
            <div id="contentA" class="ei-title mt-2">
                <label for="ei-title">
                    Job Title
                    <input class="black-input opposite-colors" (input)="inputChanged()" placeholder="Job Title" type="text" no-special-chars="#!$%^<>+='" maxlength="200" (blur)="trimSpecialChar('title');" formControlName="title">
                </label>
            </div>
            <div id="contentB" class="ei-type mt-2">
                <label for="ei-type">
                    Employment Type
                    <div class="input-icon-right">
                        <input class="black-input opposite-colors" placeholder="Select" type="text" no-special-chars="#!$%^<>+='" maxlength="100"
                        (blur)="trimSpecialChar('type');" (input)="dropdownInputChanged()"  formControlName="type" [kpmgUiTypeahead]="searchEmploymentType" (selectItem)="dropdownInputChanged()"
                        aria-autocomplete="none" aria-expanded="false" role="combobox" (blur)="dropdownInputChanged()" (click)="dropdownInputChanged()">
                        <i class="fas fa-caret-down"></i>
                    </div>
                </label>
            </div>
        </div>

        <div class="alert alert-danger section-info" role="alert" *ngIf="displayNoResultsEmployment"><i class="fas fa-exclamation-triangle"></i> No Employment Type Found</div>

        <div id="container-header" class="header-space">
            <div id="contentD">
                <i class="fas fa-building">
                </i>
            </div>

            <div id="contentE">
                <h4><b>Cost Center</b></h4>
            </div>
        </div>
        
        <div id="container">
            <div id="contentA" class="ei-location mt-2">
                <label for="ei-location">
                    Location
                    <div class="input-icon-right">
                        <input class="black-input opposite-colors" placeholder="Select" type="text"
                            formControlName="location" (input)="dropdownInputChanged()" [kpmgUiTypeahead]="searchLocation" no-special-chars="#!$@%^<>+=" (selectItem)="dropdownInputChanged()"
                            aria-autocomplete="none" aria-expanded="false" role="combobox" (blur)="dropdownInputChanged()" (click)="dropdownInputChanged()">
                            <i class="fas fa-caret-down"></i>
                    </div>
                </label>
            </div>

            <div id="contentB" class="ei-costCenter mt-2">
                <label for="ei-costCenter">
                    Cost Center Number
                    <input class="black-input opposite-colors" placeholder="Cost Center Number" type="text" maxlength="100" no-special-chars="#!$%^<>+='"
                    (blur)="trimSpecialChar('costCenter');" (input)="inputChanged()"  formControlName="costCenter">
                </label>
            </div>
        </div>

        <div class="alert alert-danger section-info" role="alert" *ngIf="displayNoResultsLocation"><i class="fas fa-exclamation-triangle"></i> No Location Found</div>

        <div id="container">
            <div id="contentC" class="ei-costCenterDesc mt-2">
                <label for="ei-costCenterDesc">
                    Cost Center Description
                    <input class="black-input opposite-colors" placeholder="Cost Center Description" type="text" maxlength="100" no-special-chars="#!$%^<>+='"
                    (blur)="trimSpecialChar('costCenterDesc');" (input)="inputChanged()" formControlName="costCenterDesc">
                </label>
            </div>
        </div>

        <div id="container-header" class="header-space">
            <div id="contentD">
                <i class="fas fa-calendar">
                </i> 
            </div>

            <div id="contentE">
                <h4><b>Employment Details</b></h4>
            </div>
        </div>
        
        <div id="container">
            <div id="contentA" class="ei-employment-dates mt-2">
                <label for="ei-hireDate">
                    Hire Date
                    <span class="input-group startdate-input">
                        <input type="text" class="black-input opposite-colors " #dpStart="bsDatepicker"  no-special-chars="#!$%^<>+='"
                            [ngClass]="{'ng-invalid': employmentDatesError}" bsDatepicker [maxDate]="maxDate"
                            placeholder="mm/dd/yyyy" [bsConfig]="{ showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY' }"
                            (bsValueChange)="setStartDate($event)" formControlName="hireDate" (focus)="onfocStartDate()" (input)="inputChanged()" />
                        <span class="input-group-append">
                            <i class="fas fa-times input-group-append-i" *ngIf="targetForm.value.hireDate"
                                (click)="clearStartDate()"></i>
                            <i class="fa fa-calendar-alt" (click)="openDatePickerStart()"></i>
                        </span>
                    </span>
                </label>
            </div>
            <div id="contentB" class="ei-employment-dates mt-2">
                <label for="ei-endDate">
                    Termination Date
                    <span class="input-group enddate-input">
                        <input type="text" class="black-input opposite-colors" #dpEnd="bsDatepicker" no-special-chars="#!$%^<>+='"
                            [ngClass]="{'ng-invalid': employmentDatesError}" bsDatepicker [maxDate]="maxDate"
                            placeholder="mm/dd/yyyy" [bsConfig]="{ showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY' }"
                            (bsValueChange)="setEndDate($event)" formControlName="endDate" (focus)="onfocEndDate()" (blur)="checkDates()" (input)="inputChanged()" />
                        <span class="input-group-append">
                            <i class="fas fa-times input-group-append-i" *ngIf="targetForm.value.endDate"
                                (click)="clearEndDate()"></i>
                            <i class="fa fa-calendar-alt" (click)="openDatePickerEnd()"></i>
                        </span>
                    </span>
                </label>
            </div>
        </div>

        <div class="form-error-sign section-info" *ngIf="employmentDatesError">
            <p>{{employeeDatesErrorMessage}}</p>
        </div>
        
        <div id="container">
            <div id="contentA" class="ei-totalHours mt-2">
                <label for="ei-totalHours">
                    Computed Hours
                    <input class="black-input opposite-colors" placeholder="0" type="number"
                        formControlName="totalHours" (focus)="onfocEF()" (input)="inputChanged()"readonly style="cursor: not-allowed;">
                </label>
            </div>
            <div id="contentB" class="ei-wage mt-2">
                <label for="ei-wage">
                    Wage Amount
                    <div class="input-icon-left">
                        <input class="black-input opposite-colors" placeholder="0.00" type="number"
                            formControlName="wage" (blur)="checkWage()" (input)="inputChanged()">
                            <i class="fas fa-dollar-sign"></i>
                    </div>
                </label>
            </div>
        </div>

        

        <div id="container">
            
            <div id="contentA" class="ei-wage mt-2">
                <label for="ei-wage">
                    PY Qualified Allocation
                    <div class="input-icon-right">
                        <input class="black-input opposite-colors" placeholder="0" min="0" max="100" formControlName="priorYearQualifiedPercentage"
                        type="number" (input)="inputChanged()"  >
                        <i class="fas fa-percent"></i>
                    </div>
                </label>
            </div>
            <div id="contentB" class="ei-totalHours mt-2">
                <label for="ei-location">
                    <i class="fas fa-asterisk"></i> Tax Period
                    <div class="input-icon-right">
                        <input class="black-input opposite-colors pointer" placeholder="Tax Period" type="text"
                            (change)="checkTaxPeriod()" (input)="dropdownInputChanged()" formControlName="taxPeriod"
                            [kpmgUiTypeahead]="searchTaxPeriod" (blur)="dropdownInputChanged()" (click)="dropdownInputChanged()" (selectItem)="dropdownInputChanged()"
                            no-special-chars="#!$@%^<>+=" aria-autocomplete="none" aria-expanded="false" role="combobox">
                        <i class="fas fa-caret-down" [ngClass]="{'caret-disabled' : taxPeriodNames?.length == 1}"></i>
                    </div>
                </label>
            </div>
        </div>

        <p class="section-info">Wage can have decimal values.</p>

        <div class="form-error-sign section-info" *ngIf="f.wage.errors && f.wage.errors.cannotBeNegativeNumber">Wage cannot be a negative number.</div>

        <div id="container">
            <div id="contentA" class="ei-sme mt-2">
                <label for="ei-sme">
                    SME
                    <div class="input-elm">
                    <input class="black-input opposite-colors" 
                    placeholder="Enter a Client User Name" type="text"    (selectItem)="dropdownInputChanged()"                 
                    formControlName="sme" [kpmgUiTypeahead]="searchSMEStream">
                    <span class="search-icon"><i class="fas fa-search"></i></span>
                    </div>
                </label>
            </div>

            <div id="contentB" class="ei-company mt-2">
                <label for="ei-company">
                    Entity
                    <input class="black-input opposite-colors" placeholder="Entity Name" type="text"
                        (selectItem)="dropdownInputChanged()" formControlName="company" (input)="inputChanged()"
                        [kpmgUiTypeahead]="searchCompany" no-special-chars="#!$@%^<>+=" aria-autocomplete="none" aria-expanded="false"
                        role="combobox">
                </label>
            </div>
        </div>
    </section>
    <footer class="endFormSubmit info-tile">
        <button type='button' class="btn btn-success" (click)="postRightSideDrawerData()"
            [disabled]="!targetForm.valid || employmentDatesError || employeeNumberError || addDisabledLocation || addDisabledEmployment || addDisabledTaxPeriod || !isEmpValueEntered">Add Employee</button>
        <button class="btn kpmg-button--flat"
            (click)="rightSideDrawerService.closeRightSideDrawer();resetRightSideDrawerData()">Cancel</button>
    </footer>
</form>
